// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Körpergewicht: online-only, streng owner-scoped (Serverregel), ein Wert pro Tag.
// Fehler werfen — die Seite zeigt den Toast. (ponytail: kein Offline-Cache, erst wenn ihn jemand vermisst)
import { pb } from "./pb"

export interface BodyWeight {
  id: string
  owner: string
  date: string // PB-Datum; Tagesteil via dayOf()
  weight_kg: number
}

export async function loadWeights(): Promise<BodyWeight[]> {
  return pb.collection("body_weights").getFullList<BodyWeight>({ sort: "date" })
}

/** Gewicht für einen Tag setzen: create; kollidiert der Unique-Index (owner+date) → update. */
export async function upsertWeight(dateISO: string, kg: number): Promise<void> {
  const owner = pb.authStore.record?.id ?? ""
  try {
    await pb.collection("body_weights").create({ owner, date: dateISO, weight_kg: kg })
  } catch (err) {
    if ((err as { status?: number }).status !== 400) throw err
    const existing = await pb.collection("body_weights").getFirstListItem<BodyWeight>(
      `owner = "${owner}" && date = "${dateISO} 00:00:00.000Z"`,
    )
    await pb.collection("body_weights").update(existing.id, { weight_kg: kg })
  }
}
